export default "__VITE_ASSET__DZ$1iyvO__"